import React, {useState, useEffect} from "react";
import {
  Avatar,
  Typography,
  Paper,
  InputBase,
  IconButton,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core";
import { Send, MoreVert } from "@material-ui/icons";
// import { useCollectionData } from "react-firebase-hooks/firestore";

import { useAuth } from "../../../../contexts/AuthContext";
import ChatItemReceive from "./ChatItemReceive";
import ChatItemSend from "./ChatItemSend";

import Logo from "../../../../getKampus.png";
import { firestore } from "../../../../firebase";
import {
  collection,
  query,
  orderBy,
  limit,
  addDoc,
  serverTimestamp,
  onSnapshot,
} from "@firebase/firestore";

const useStyles = makeStyles((theme) => ({
  main: {
    // width: "100%",
    padding: "0px 5px",
    height: "84.5vh",
    display: "flex",
    flexDirection: "column",
    // borderRight: "1px solid darkblue",
    // borderLeft: "1px solid darkblue",
    // backgroundColor: theme.palette.background.paper,
  },
  header: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    borderBottom: "1px solid darkblue",
    backgroundColor: theme.palette.background.paper,
    display: "flex",
    alignItems: "center",
    height: "8vh",
  },
  avatarHeader: {
    marginRight: theme.spacing(2),
    marginLeft: theme.spacing(2),
  },
  moreButton: {
    [theme.breakpoints.up("lg")]: {
      display: "none",
    },
    marginRight: 15,
  },
  body: {
    // height: "70vh",
    backgroundColor: theme.palette.background.paper,
    overflowY: "scroll",
    borderBottom: "1px solid darkblue",
    paddingTop: theme.spacing(1),
  },
  footer: {
    //backgroundColor: theme.palette.background.paper,
    marginBottom: theme.spacing(1),
  },
  messageMain: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "2px 4px",
    marginTop: theme.spacing(1),
    // marginRight: theme.spacing(2),
    // marginLeft: theme.spacing(2),
    // marginBottom: theme.spacing(4)
  },
  messageInput: {
    flex: 1,
    paddingLeft: theme.spacing(1),
  },
}));

export default function ChatContent() {
  const classes = useStyles();
  const { currentUser } = useAuth();
  const [messages, setMessages] = useState([]);
  
  useEffect(() => {
    const messagesRef = collection(firestore, "Chat");
    const q = query(messagesRef, orderBy("createdAt","desc"), limit(20));
    const unsubscribe = onSnapshot(q, (querySnapshot) =>{
      const message = [];
      querySnapshot.forEach((doc) => {
        message.push(doc.data());
      })
      setMessages(message.slice(0).reverse());
    })
    return unsubscribe;
  }, [])

  // const [messages] = useCollectionData(q, { idField: "id" });
  // console.log(messages);

  const [formValue, setFormValue] = useState("");

  const handleSendMessage = async (event) => {
    event.preventDefault();
    const messagesRef = collection(firestore, "Chat");
    const { uid, photoURL } = currentUser;
    await addDoc(messagesRef, {
      text: formValue,
      createdAt: serverTimestamp(),
      uid,
      photoURL,
      name: currentUser.displayName.substr(0,8),
    });
    setFormValue("");
  };

  return (
    <div className={classes.main}>
      <div className={classes.header}>
        <Avatar src={Logo} className={classes.avatarHeader} />
        <div style={{ flexGrow: 1 }}>
          <Typography variant="h6">National University of Singapore</Typography>
          <Typography variant="body2">5 Online</Typography>
        </div>
        <IconButton className={classes.moreButton}>
          <MoreVert />
        </IconButton>
      </div>
      <div className={classes.body}>
        {messages &&
          messages.map((msg, index) =>
            msg.uid === currentUser.uid ? (
              <ChatItemSend key={index} message={msg} />
            ) : (
              <ChatItemReceive key={index} message={msg} />
            )
          )}
      </div>
      <div className={classes.footer}>
        <Paper
          component="form"
          className={classes.messageMain}
          onSubmit={handleSendMessage}
        >
          <InputBase
            className={classes.messageInput}
            placeholder="Send Message..."
            value={formValue}
            onChange={(e) => setFormValue(e.target.value)}
          />
          <IconButton
            type="submit"
            className={classes.iconButton}
            aria-label="send"
          >
            <Send />
          </IconButton>
        </Paper>
      </div>
    </div>
  );
}
